<script>
import { get } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { kenwoodItalyBasicMixin, kenwoodItalyRelatedMixin } from "../../modules/kenwood_italy_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin, kenwoodItalyRelatedMixin],
  props: {
    tagExtraField: String,
    optionalRelatedContentNames: Array,
  },
  computed: {
    tileLayout() {
      return "tile-article";
    },
    articleFiltering() {
      const name = Fandom.retrieveFromGlobalState("article_filter", false);
      return name ? [name] : [];
    }
  },
  mounted() {
    const tag = get(this.content, this.tagExtraField, this.content.decorators.default);
    if (!this.optionalRelatedContentNames) {
      this.getRelatedContents(tag, this.tileLayout, this.articleFiltering);
    } else {
      this.getRelatedContentsByNames(this.optionalRelatedContentNames, this.tileLayout, this.articleFiltering);
    }
  }
};
</script>

<template>
  <div class="bg-kenwood-light-grey" stripe-related-articles>
    <div class="container">
      <div class="row justify-content-md-center pt-4">
        <div class="col-sm-8 text-center pt-2 mx-auto">
          <span class="font-xs text-uppercase">
            {{ft('globals.more_on')}}
          </span>
        </div>
      </div>
    </div>
    <grid-fixed tileAdditionalPaddingClass="px-4" :content="resultContent" v-if="resultContent" :trackTileClick="['Interaction', 'Related Click']"></grid-fixed>
  </div>
</template>
